/**
 * Formate une date YYYY-MM-DD ou ISO vers JJ/MM/AAAA.
 * Les chaînes YYYY-MM-DD sont traitées sans décalage de fuseau.
 */
export function fmtDate(date: string | Date | null | undefined): string {
  if (!date) return '';
  if (typeof date === 'string') {
    const m = date.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${d.getFullYear()}`;
}

/**
 * Accepte JJ/MM/AAAA, JJ-MM-AAAA, JJ.MM.AAAA ou YYYY-MM-DD → YYYY-MM-DD.
 * Retourne null si la date est illisible ou invalide (ex. 31/02).
 */
export function parseFlexibleDateToIso(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return isRealIsoDate(s) ? s : null;
  }

  const fr = s.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/);
  if (!fr) return null;
  const day = Number(fr[1]);
  const month = Number(fr[2]);
  const year = Number(fr[3]);
  if (!Number.isFinite(day) || !Number.isFinite(month) || !Number.isFinite(year)) return null;
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const iso = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return isRealIsoDate(iso) ? iso : null;
}

function isRealIsoDate(iso: string): boolean {
  const [ys, ms, ds] = iso.split('-');
  const y = Number(ys);
  const m = Number(ms);
  const d = Number(ds);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}

const MOIS_FR = [
  'janvier',
  'fevrier',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'aout',
  'septembre',
  'octobre',
  'novembre',
  'decembre',
];

export function fmtMonth(periode: string): string {
  const [annee, mois] = periode.split('-');
  const m = parseInt(mois ?? '0', 10) - 1;
  return `${MOIS_FR[m] ?? mois} ${annee}`;
}

export function periodeFromDate(date: string | Date): string {
  if (typeof date === 'string') {
    const m = date.trim().match(/^(\d{4})-(\d{2})/);
    if (m) return `${m[1]}-${m[2]}`;
  }
  const d = typeof date === 'string' ? new Date(date) : date;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
